import { i18n } from '@/plugins/i18n'
import {paymentStatus, paymentStatusStr} from "@/constants/PaymentStatus";
import {contractStatusStr, contractStatusVariant} from "@/constants/onlineContract";
export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'left', // in rtl version means right
    },
    {
        field: 'contract_title',
        title: i18n.t('label.title'),
        sortable: false,
        textAlign: 'center'
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center'
    },
    {
        field: 'start_at',
        title: i18n.t('online_contract.start_at'),
        sortable: true,
        textAlign: 'center'
    },
    {
        field: 'end_at',
        title: i18n.t('online_contract.end_at'),
        sortable: true,
        textAlign: 'center'
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        template: (row, index, datatable) => {
            let status = contractStatusStr.get(row.status)
            let variant = 'badge-' + contractStatusVariant(row.status)

            return '<div class="badge ' + variant + ' text-white">' + status + '</div>'
        },
        sortable: true,
        width: 80,
        textAlign: 'center'
    },
    {
        field: 'payment_status',
        title: i18n.t('online_contract.payment_status_title'),
        template: (row, index, datatable) => {
            if (row.payment_status === paymentStatus.UNPAID) {
                return `<span class="badge badge-info">${paymentStatusStr.get(paymentStatus.UNPAID)}</span>`
            } else if (row.payment_status === paymentStatus.PAID) {
                return `<span class="badge badge-success">${paymentStatusStr.get(paymentStatus.PAID)}</span>`
            } else {
                return `<span class="badge badge-dark">${paymentStatusStr.get(paymentStatus.PAID_BY_ADMIN)}</span>`
            }
        },
        sortable: true,
        width: 80,
        textAlign: 'center'
    },
]